export const getLink = str => {
  const regex = /(https?:\/\/[^\s]+)/g
  const match = regex.exec(str)
  return match ? match[0] : null
}
